import { render, staticRenderFns } from "./ReportMetaRegions.vue?vue&type=template&id=82490dae"
import script from "./ReportMetaRegions.vue?vue&type=script&lang=js"
export * from "./ReportMetaRegions.vue?vue&type=script&lang=js"
import style0 from "./ReportMetaRegions.vue?vue&type=style&index=0&id=82490dae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports